<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<div class="senseline">
<p class="epslf"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Thus altering Age leads on the World to Fate,</p>
<p class="epsl">The Earth is different from her former state.</p>
</div>
<p class="ept">—Lucretius, <i>De rerum natura</i> (Thomas Creech translation, 1682)</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-menely-0005.vue?ff692722